import intl from "react-intl-universal";
import { TbCalendar, TbCurrencyReal } from "react-icons/tb";
import { CurrencyIcon } from "../../../../Components/Atoms/CurrencyIcon";
import { ModernFilterBar } from "../../../../Components/Molecules/Filters/ModernFilterBar";
import {
  AmountFilterPanel,
  CheckboxListFilterPanel,
  DateFilterPanel,
  MoreFiltersAmountSection,
  MoreFiltersCheckboxSection,
  MoreFiltersDateSection,
} from "../../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  EMPTY_EXCHANGE_FILTERS,
  EXCHANGE_CURRENCIES,
  buildExchangeFilterTags,
  exportExchangeCsv,
  getExchangeStatusOptions,
  hasActiveExchangeFilters,
  isExchangeChipFilterActive,
  removeExchangeFilterTag,
} from "../contaInternacionalExchangeFilters";

const ExchangeCurrencyFilterIcon = ({ asset }) => <CurrencyIcon asset={asset} size={18} />;

const getExchangeCurrencyOptionIcon = (option) => {
  const Icon = () => <ExchangeCurrencyFilterIcon asset={option.id} />;
  return Icon;
};

const ExchangeFromFilterButtonIcon = ({ className }) => (
  <CurrencyIcon asset="usd" size={16} className={className} />
);

const ExchangeToFilterButtonIcon = ({ className }) => (
  <CurrencyIcon asset="brl" size={16} className={className} />
);

const ExchangeMoreFiltersForm = ({ draft, onChange }) => {
  const statuses = getExchangeStatusOptions();

  return (
    <div className="extract-more-filters-form">
      <MoreFiltersDateSection draft={draft} onChange={onChange} />
      <MoreFiltersAmountSection
        draft={draft}
        onChange={onChange}
        idPrefix="exchange-more"
        minLabelKey="contaInternacional.amountMin"
        maxLabelKey="contaInternacional.amountMax"
      />
      <MoreFiltersCheckboxSection
        label={intl.get("contaInternacional.filterCurrencyFrom")}
        options={EXCHANGE_CURRENCIES}
        selectedValues={draft.fromCurrencies}
        onChange={(fromCurrencies) => onChange({ ...draft, fromCurrencies })}
        idPrefix="exchange-more-from"
        getOptionIcon={getExchangeCurrencyOptionIcon}
      />
      <MoreFiltersCheckboxSection
        label={intl.get("contaInternacional.filterCurrencyTo")}
        options={EXCHANGE_CURRENCIES}
        selectedValues={draft.toCurrencies}
        onChange={(toCurrencies) => onChange({ ...draft, toCurrencies })}
        idPrefix="exchange-more-to"
        getOptionIcon={getExchangeCurrencyOptionIcon}
      />
      <MoreFiltersCheckboxSection
        label={intl.get("grid.status")}
        options={statuses}
        selectedValues={draft.statuses}
        onChange={(statuses) => onChange({ ...draft, statuses })}
        idPrefix="exchange-more-status"
      />
    </div>
  );
};

export const ContaInternacionalExchangeFilterBar = ({
  filters,
  onFiltersChange,
  filteredItems,
}) => {
  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("extract.filterDate"),
      active: isExchangeChipFilterActive(filters, "date"),
    },
    {
      id: "amount",
      icon: TbCurrencyReal,
      label: intl.get("extract.filterAmount"),
      active: isExchangeChipFilterActive(filters, "amount"),
    },
    {
      id: "from",
      icon: ExchangeFromFilterButtonIcon,
      label: intl.get("contaInternacional.filterCurrencyFrom"),
      active: isExchangeChipFilterActive(filters, "from"),
    },
    {
      id: "to",
      icon: ExchangeToFilterButtonIcon,
      label: intl.get("contaInternacional.filterCurrencyTo"),
      active: isExchangeChipFilterActive(filters, "to"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "amount":
        return (
          <AmountFilterPanel
            draft={draft}
            onChange={onChange}
            idPrefix="exchange-filter"
            minLabelKey="contaInternacional.amountMin"
            maxLabelKey="contaInternacional.amountMax"
          />
        );
      case "from":
        return (
          <CheckboxListFilterPanel
            options={EXCHANGE_CURRENCIES}
            selectedValues={draft.fromCurrencies}
            onChange={(fromCurrencies) => onChange({ ...draft, fromCurrencies })}
            idPrefix="exchange-from"
            getOptionIcon={getExchangeCurrencyOptionIcon}
          />
        );
      case "to":
        return (
          <CheckboxListFilterPanel
            options={EXCHANGE_CURRENCIES}
            selectedValues={draft.toCurrencies}
            onChange={(toCurrencies) => onChange({ ...draft, toCurrencies })}
            idPrefix="exchange-to"
            getOptionIcon={getExchangeCurrencyOptionIcon}
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_EXCHANGE_FILTERS}
      searchPlaceholder={intl.get("contaInternacional.searchExchange")}
      filterButtons={filterButtons}
      moreFiltersActive={isExchangeChipFilterActive(filters, "more")}
      buildFilterTags={buildExchangeFilterTags}
      hasActiveFilters={hasActiveExchangeFilters}
      removeFilterTag={removeExchangeFilterTag}
      onExport={exportExchangeCsv}
      filteredItems={filteredItems}
      renderPanelContent={renderPanelContent}
      renderMoreFilters={(draft, onChange) => (
        <ExchangeMoreFiltersForm draft={draft} onChange={onChange} />
      )}
      panelTitles={{
        date: intl.get("extract.filterDate"),
        amount: intl.get("extract.filterAmount"),
        from: intl.get("contaInternacional.filterCurrencyFrom"),
        to: intl.get("contaInternacional.filterCurrencyTo"),
      }}
    />
  );
};
